import { msg } from "@lingui/core/macro";

export const maxTenantPlateLimitRuleMessages = {
	name: msg({ message: "Maximum Plates Per Tenant Permit" }),
	description: msg({ message: "The maximum amount of plates a tenant may have on a permit" }),
	errors: {
		plateLimitReached: msg({
			message: "This permit allows {amount} plates per permit. Delete or update an existing plate.",
		}),
	},
} as const;
